import React from "react";
import {
  RiFacebookCircleLine,
  RiInstagramLine,
  RiTwitterLine,
  RiYoutubeLine,
} from "react-icons/ri";

const Footer = () => {
  return (
    <div className="bg-gradient-to-r from-foo-left to-foo-right bottom-0 p-4 w-100">
      <div className="flex flex-col md:flex-row w-100 justify-center bg-gradient-to-r from-foo-left to-foo-right mr-0">
        <div className="flex flex-col items-center justify-center w-full h-full max-md:pb-5 text-white ">
          <h1 className="text-2xl pb-2">Quick Link</h1>
          <div className="flex flex-row justify-center w-full h-full text-white ">
            <ul>
              <li className=" text-start ml-5 leading-6">
                <p>Home</p>
              </li>
              <li className=" text-start ml-5 leading-6">
                <p>Sai Temple</p>
              </li>
              <li className=" text-start ml-5 leading-6">
                <p>Notification</p>
              </li>
              <li className=" text-start ml-5 leading-6">
                <p>Online Booking</p>
              </li>
              <li className=" text-start ml-5 leading-6">
                <p>Contact Us</p>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center w-full h-full max-md:pb-5 text-white ">
          <h1 className="text-2xl pb-2">Follow Us On</h1>
          <div className="flex flex-row justify-center w-full h-full text-white ">
            <ul>
              <li className="flex items-center justify-between text-start ml-5 leading-6">
                <p>Facebook</p>
                <RiFacebookCircleLine className="ml-3 text-xl" />
              </li>
              <li className="flex items-center justify-between text-start ml-5 leading-6">
                <p>Instagram</p>
                <RiInstagramLine className="ml-3 text-xl" />
              </li>
              <li className="flex items-center justify-between text-start ml-5 leading-6">
                <p>Twitter</p>
                <RiTwitterLine className="ml-3 text-xl" />
              </li>
              <li className="flex items-center justify-between text-start ml-5 leading-6">
                <p>YouTube</p>
                <RiYoutubeLine className="ml-3 text-xl" />
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center w-full h-full max-md:pb-5 text-white ">
          <h1 className="text-2xl pb-2">Reach Us On</h1>
          <div className="flex flex-row justify-center w-full h-full text-white ">
            <address className="text-start">
              For Online Services please do contact on: <br />
              <a href="tel:+91 22 2414 3434">+91 22 2414 3434</a>/
              <a href="tel:+91 22 2414 3435">+91 22 2414 3435</a>
              <br />
              Helpline No.: <br />
              <a href="tel:+91 22 2414 3436">+91 22 2414 3436</a>/
              <a href="tel:+91 22 2414 3437">+91 22 2414 3437</a>/
              <a href="tel:+91 22 2414 3438">+91 22 2414 3438</a>
            </address>
          </div>
        </div>
      </div>
      <div>
        <div className="flex flex-col items-center justify-center w-full h-full max-md:pb-5 text-white ">
          <p>© Copyright 1998-2023 Shri Saibaba Sansthan Trust, Shirdi</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
